import { Space } from 'antd';
import styled from 'styled-components';

export const BackToAppsStyled = styled(Space)`
	margin-bottom: 28px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-bottom: 0;
	}
`;
